export function createI18nStringFields(key: string, value: string): Record<string, string> {
  return {
    [key]: value,
    [`${key}-i18n`]: value,
  };
}

export function createI18nStringArrayFields(key: string, values: Array<string>): Record<string, Array<string>> {
  return {
    [key]: values,
    [`${key}-i18n`]: values,
  };
}
